import React, { ReactElement, useState } from "react";

import Burger from "./Burger/Burger";
import { Container } from "./styles";

import Menu from "~/components/BurgerMenu/Menu";

type Props = {
  itemsToShowOnBurgerMenu: ReactElement[];
};

export default function BurgerMenu({ itemsToShowOnBurgerMenu }: Props) {
  const [openMenu, setOpenMenu] = useState(false);

  return (
    <Container>
      <Burger isMenuOpen={openMenu} setOpen={setOpenMenu} />
      <Menu items={itemsToShowOnBurgerMenu} isMenuOpen={openMenu} />
    </Container>
  );
}
